import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Paper } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { generateRoute } from '../../../../utils/location';
import { readableFormat } from '../../../../utils/transformationHelper';
import { AppMarketPageIdentifier } from '../../../../AppRoutes';
import { useCollectionsRelatedToApp } from '../../../../hooks/useCollectionsRelatedToApp';

interface ComponentProps {
  appId: Uuid;
}

export const FeaturedCollections: React.FC<ComponentProps> = ({ appId}): JSX.Element | null => {
  const { t } = useTranslation();
  const collectionsRelatedToApp = useCollectionsRelatedToApp(appId);
  return collectionsRelatedToApp.length > 0 ? (
    <Paper square className={styles.featuredCollectionWrapper}>
      <h4 className={styles.featuredHeading}>{t('app_details.featured_in')}</h4>
      <div className={styles.featuredItemContainer}>
        {collectionsRelatedToApp.map(collection => (
          <div key={collection.id} className={styles.featuredItem}>
            <RouterLink to={generateRoute(AppMarketPageIdentifier.Collections, collection.id)}>
              <p>{readableFormat(collection.displayName)}</p>
            </RouterLink>
          </div>
        ))}
      </div>
    </Paper>
  ) : null; // Don't render component if that are no collections
};
